/* eslint-disable max-classes-per-file */
import { Expose, Transform, Type } from 'class-transformer'
import { CategoryType } from '@models/category/CategoryType'
import { TagType } from '@models/story/TagType'
import { BookEnum } from '@interfaces/BookEnum'
import { AffiliationEnum } from '@interfaces/AffiliationEnum'
import { WriterStatusEnum } from '@interfaces/WriterStatusEnum'
import { WritingEnum } from '@interfaces/WritingEnum'
import { BookRatingType } from '@models/book/BookRatingType'
import { BookBuyAllChapterPromotion } from '@models/book/BookBuyAllChapterPromotion'
import { BookReadFreePromotion } from '@models/book/BookReadFreePromotion'
import { BookBadge } from '@models/book/BookBadge'
import { BookChapterCampaignHeader } from '@models/book/BookChapterCampaignHeader'

class WriterType {
  affiliation: AffiliationEnum

  status: WriterStatusEnum
}

class UserType {
  id: number

  @Type(() => WriterType)
  writer: WriterType

  profilePageSlug: string

  displayName: string

  avatarImgPath: string
}

class PenNameType {
  firstPenName: string

  @Type(() => UserType)
  user: UserType
}

export class NewestType {
  @Expose()
  id: number

  @Expose()
  writer: string

  @Expose()
  coverImgPath: string

  @Expose()
  coverResizeImgPath: string

  @Expose()
  title: string

  @Expose()
  cover: string

  @Expose()
  penName: PenNameType

  @Expose()
  @Type(() => TagType)
  tags: TagType[]

  @Expose()
  category: CategoryType

  @Expose()
  viewCount: number

  @Expose()
  likeCount: number

  @Expose()
  commentCount: number

  @Expose({ name: 'publishedChapterCount' })
  chapterCount: number

  @Expose()
  isEnded: boolean

  @Expose()
  bookType: BookEnum

  @Transform(({ value }) => value ?? false)
  isLiked: boolean

  @Expose()
  publishedAt: string

  @Expose()
  writingType: WritingEnum

  @Expose()
  isTranslated: boolean

  @Expose()
  isEpub: boolean

  @Expose()
  isPdf: boolean

  @Expose()
  @Type(() => BookRatingType)
  rating: BookRatingType

  @Expose() hasSalePromotions?: boolean

  @Expose()
  @Type(() => BookBuyAllChapterPromotion)
  buyAllChaptersPromotion?: BookBuyAllChapterPromotion

  @Expose()
  @Type(() => BookReadFreePromotion)
  readFreePromotion?: BookReadFreePromotion

  @Expose()
  @Type(() => BookBadge)
  bookBadges?: BookBadge[]

  @Expose()
  @Type(() => BookChapterCampaignHeader)
  bookChapterCampaignHeader?: BookChapterCampaignHeader
}
